import React from "react";
import { useTranslation } from "react-i18next";
import "./BottomNav.css";

type BottomNavProps = {
  inicioHref?: string;
  inscricaoHref?: string;
  meusHorariosHref?: string;
};

export default function BottomNav({
  inicioHref = "/",
  inscricaoHref = "/escolha-tipo-inscricao",
  meusHorariosHref = "/meus-horarios"
}: BottomNavProps) {
  const { t } = useTranslation();

  return (
    <nav className="bottom-nav">
      <a href={inicioHref}>{t("components.bottomNav.inicio")}</a>
      <span>-</span>
      <a href={inscricaoHref}>{t("components.bottomNav.inscricao")}</a>
      <span>-</span>
      <a href={meusHorariosHref}>{t("components.bottomNav.meusHorarios")}</a>
    </nav>
  );
}
